import RequestService from '~/api/services/request';

export default new RequestService('admin');
